import { jsx } from '@emotion/react/jsx-runtime';
import { cx } from '@emotion/css';
import { useCss, cloneElementWithCss } from '@nettbureau/styling';
import { useContext, Children, isValidElement, createContext } from 'react';
import { createComponent } from '../system/factories.js';
import '@react-aria/utils';
import 'ramda';
import 'react-aria';

/**
 * Context providing information about whether a disabled effect is active in the current tree.
 */ const DisabledContext = /*#__PURE__*/ createContext(false);
/**
 * The disabled effect component can be wrapped around an element to conditionally apply a faded out effect.
 * It uses a disabled context to make sure the effect is only applied once.
 */ const DisabledEffect = createComponent((props)=>{
    const { children, className, disableGrayScale, disabled = false, important, ...otherProps } = props;
    const disabledEffectActive = useContext(DisabledContext);
    const css = useCss(({ theme })=>disabled && !disabledEffectActive && [
            {
                cursor: 'auto'
            },
            !disableGrayScale && {
                filter: 'grayscale(30%)'
            },
            {
                cursor: 'default',
                opacity: `${theme.opacities.weaker} ${important ? ' !important' : ''}`
            }
        ]);
    const child = Children.only(children);
    return /*#__PURE__*/ jsx(DisabledContext.Provider, {
        value: disabled,
        children: /*#__PURE__*/ isValidElement(child) ? cloneElementWithCss(child, {
            ...otherProps,
            className: child.props.className ? cx(child.props.className, className) : className,
            css
        }) : null
    });
});

export { DisabledEffect };
//# sourceMappingURL=disabled-effect.js.map
